var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIsBeforeNow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M21 6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M15.4 6a.4.4 0 0 0-.4.4v.933H9.333V6.4a.4.4 0 0 0-.8 0v.933H7.5a1.5 1.5 0 0 0-1.5 1.5V10h.005a1 1 0 0 0-.005.083V16.5A1.5 1.5 0 0 0 7.5 18h9a1.5 1.5 0 0 0 1.5-1.5v-6.417a1 1 0 0 0-.005-.083H18V8.833a1.5 1.5 0 0 0-1.5-1.5h-.7V6.4a.4.4 0 0 0-.4-.4m1.7 10.5v-6.267H6.9V16.5a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M10.454 14.024h2.259a.33.33 0 0 0 .24-.096.33.33 0 0 0 .097-.24.33.33 0 0 0-.097-.24.33.33 0 0 0-.24-.098h-2.258l.96-.96a.3.3 0 0 0 .097-.236.344.344 0 0 0-.337-.341.31.31 0 0 0-.24.097l-1.542 1.542a.3.3 0 0 0-.072.11.4.4 0 0 0-.021.126q0 .067.021.126.021.06.072.11l1.542 1.541a.31.31 0 0 0 .24.097.344.344 0 0 0 .337-.34.3.3 0 0 0-.097-.237l-.96-.96Zm4.246-2.211a.375.375 0 0 0-.75 0v3.75a.375.375 0 0 0 .75 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIsBeforeNow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/is-before-now.9a3740c5.svg";